import React from "react";

const MessageSpace = ({ ...props }) => {
  return <main {...props} />;
};
export default MessageSpace;
